<div class="spacing--margin-top" *ngIf="!isReferenceFeedAdvice">
  <h3>{{ 'create-feed-advice.location.panel-title' | translate }}</h3>
  <div class="spacing--margin-top flex--row flex--nowrap">
    <div class="flex--column spacing--padding-right padding-top-5" *ngIf="locations$ | async">
      <agr-chips-filter
        [multiple]="true"
        [items]="locationChipItems"
        (change)="changeLocation($event)"
        data-test="chip-locations"
      ></agr-chips-filter>
    </div>
  </div>
</div>
<div class="spacing--margin-top" *ngIf="isFatteningOrRearingOrWeaningPigletsFeedadvice()">
  <h3>{{ 'create-feed-advice.properties.panel-title' | translate }}</h3>
  <app-feed-advice-properties
    [feedAdviceType]="feedAdviceType"
    [genders]="genders"
    [feedintake]="feedintake"
    [phaseTransition]="phaseTransition"
    [phases]="phases"
    [terminalBoar]="terminalBoar"
    [geneticLine]="geneticLine"
    [isFilter]="false"
    [inputSystem]="inputSystem"
    [weaningWeight]="weaningWeight"
    [weaningAge]="weaningAge"
    [rearingAge]="rearingAge"
    [selectedDosatorSettingsId]="selectedDosatorSettingsId"
    [feedingType]="feedingType"
    (propertiesChanged)="changeFeedAdviceProperties($event)"
  ></app-feed-advice-properties>
</div>
<div class="spacing--margin-top" *ngIf="isSowsFeedadvice()">
  <h3>{{ 'create-feed-advice.properties.panel-title' | translate }}</h3>
  <app-sows-feed-advice-properties
    [feedAdviceType]="feedAdviceType"
    [bodyCondition]="bodyCondition"
    [geneticLine]="geneticLine"
    [transitionDay]="transitionDay"
    [pigletsPerFarrowingCategory]="pigletsPerFarrowingCategory"
    (propertiesChanged)="changeFeedAdviceProperties($event)"
  >
  </app-sows-feed-advice-properties>
</div>
